import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import store from '@/store/index.js'
import router from '@/router/index.js'
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);
Vue.use(ElementUI);
Vue.config.productionTip = false
import 'animate.css';
import apiList from './common/api.js'
Vue.prototype.$api = apiList
Vue.prototype.getImgSrc = function(img) {
	return 'https://www.zhaowaixie.com' + img;
	// return 'http://zhaowaixie.web.hlidc.cn' + img;

}
const uploadPath = 'https://www.zhaowaixie.com/api/'
// const uploadPath = 'http://zhaowaixie.web.hlidc.cn/api/'

Vue.prototype.uploadPath = uploadPath
import timeConversion from './utils/timeConversion.js'
import formatRichText from './utils/formatRichText.js'
import {
	showLoading,
	hideLoading
} from './common/loading.js';
Vue.prototype.timeConversion = timeConversion
Vue.prototype.formatRichText = formatRichText
Vue.prototype.showLoading = showLoading
Vue.prototype.hideLoading = hideLoading
import share from 'vue-social-share'
import plugin from './utils/util.js';
import {
	message
} from './utils/resetMsg.js' // reset message
Vue.prototype.$message = message

Vue.use(plugin);
Vue.use(share);

new Vue({
	render: h => h(App),
	store,
	router
}).$mount('#app')